import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useAppStore } from '../store/appStore';
import { useI18n } from '../i18n';
import { AvailabilityCalendar } from '../components';

export function CalendarPage() {
  const navigate = useNavigate();
  const { isAuthenticated, isChecking } = useAppStore();
  const { language } = useI18n();

  // Show loading while checking auth
  if (isChecking) {
    return (
      <div className="min-h-screen bg-slate-50 dark:bg-slate-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-amber-500 border-t-transparent"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    navigate('/prijava');
    return null;
  }

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-2">
              {language === 'sr' ? 'Kalendar dostupnosti' : 'Availability Calendar'}
            </h1>
            <p className="text-slate-600 dark:text-slate-400">
              {language === 'sr' 
                ? 'Postavite kada ste dostupni za razgledanje nekretnina' 
                : 'Set when you are available for property viewings'}
            </p>
          </div>

          {/* Calendar Component */}
          <AvailabilityCalendar defaultExpanded={true} />
        </motion.div>
      </div>
    </div>
  );
}
